<template>
  <div class="relative" style="height: 100vh;">
    <div class="section-block">
      <h4 class="clof font32 center">相关链接</h4>
      <line-cross></line-cross>
      <ul class="link-list clearfix">
        <li><a href="http://www.gov.cn/" target="_blank">
          <img src="../../assets/img/service_img1.png" alt=""></a></li>
        <li><a href="http://www.drc.gov.cn/" target="_blank">
          <img src="../../assets/img/service_img2.png" alt=""></a></li>
        <li><a href="http://www.tushengcn.com/" target="_blank">
          <img src="../../assets/img/service_img14.png" alt=""></a></li>
        <li><a href="http://www.cikd.org" target="_blank">
          <img src="../../assets/img/service_img3.png" alt=""></a></li>
        <li><a href="http://www.mwm.net.cn/" target="_blank">
          <img src="../../assets/img/service_img4.png" alt=""></a></li>
        <li><a href="http://jjsb.cet.com.cn/" target="_blank">
          <img src="../../assets/img/service_img5.png" alt=""></a></li>
        <li><a href="http://www.develpress.com.cn/" target="_blank">
          <img src="../../assets/img/service_img6.png" alt=""></a></li>
        <li><a href="http://www.cdrf.org.cn/" target="_blank">
          <img src="../../assets/img/service_img7.png" alt=""></a></li>
        <li><a href="http://www.cdrf.org.cn/" target="_blank">
          <img src="../../assets/img/service_img9.png" alt=""></a></li>
        <li><a href="http://www.qnzk.org/" target="_blank">
          <img src="../../assets/img/service_img10.png" alt=""></a></li>
        <li><a href="http://www.srit.com.cn" target="_blank">
          <img src="../../assets/img/service_img11.png" alt=""></a></li>
        <li><a href="http://www.sritidc.com.cn/" target="_blank">
          <img src="../../assets/img/service_img12.png" alt=""></a></li>
        <li><a href="http://www.srcs.com.cn/" target="_blank">
          <img src="../../assets/img/service_img13.png" alt=""></a></li>
        <li><a href="http://www.sritsoft.com/index.html" target="_blank">
          <img src="../../assets/img/service_img15.png" alt=""></a></li>
        <li><a href="http://misc.drcnet.com.cn/us/youqlj.aspx" target="_blank">
          <img src="../../assets/img/service_img16.png" alt=""></a></li>
      </ul>
    </div>
    <footer-nav class="footer"></footer-nav>
  </div>
</template>

<script>
import LineCross from './LineCross';
import FooterNav from '../../components/FooterNav';

export default {
  name: 'HomeFour',
  components: { LineCross, FooterNav },
};
</script>

<style scoped lang="scss">
.link-list{
  width: 1090px;
  margin: 22px auto 0;
  li{
    float: left;
    width: 210px;
    height: 115px;
    background: white;
    margin-right: 10px;
    margin-bottom: 10px;
    img{
      width: 100%;
      height: 100%;
    }
    &:nth-child(5n){
      margin-right: 0;
    }
  }
}
.footer{
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>
